import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';

const ResumeLoadingOverlay = ({ message = 'Loading your resume…' }) => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      zIndex: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: (theme) =>
        theme.palette.mode === 'dark' ? 'rgba(18, 18, 18, 0.72)' : 'rgba(255, 255, 255, 0.82)',
      backdropFilter: 'blur(6px)',
    }}
  >
    <Box sx={{ textAlign: 'center', px: 3 }}>
      <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2.5 }}>
        <Box
          sx={{
            position: 'absolute',
            inset: -8,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            opacity: 0.25,
            filter: 'blur(12px)',
            animation: 'pulse 2s ease-in-out infinite',
            '@keyframes pulse': {
              '0%, 100%': { transform: 'scale(1)', opacity: 0.25 },
              '50%': { transform: 'scale(1.08)', opacity: 0.4 },
            },
          }}
        />
        <CircularProgress
          size={72}
          thickness={3}
          sx={{
            color: 'primary.main',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <DescriptionIcon sx={{ fontSize: 28, color: 'primary.main', opacity: 0.9 }} />
        </Box>
      </Box>
      <Typography variant="body1" fontWeight={600} color="text.primary">
        {message}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
        This usually takes a moment
      </Typography>
    </Box>
  </Box>
);

export default ResumeLoadingOverlay;
